module.exports = __webpack_public_path__ + "img/4.9a3d6dce.png";